<template>
<div style="margin-bottom:3em" class="caja-contacto row" >
   
    
    <div  v-for="contenido in contenidos" :key="contenido.ContenidoDeMicrositioId" class="contacto col-12 card"  :class="columnasContenido(contenido.TamanoDeLaColumna)">
      <div class="card-header titulo">  <h3>{{contenido.TextoDelContenido}}</h3>   </div>
        <iframe v-if="contenido.RutaDeArchivo!=null" :src="contenido.RutaDeArchivo" 
    frameborder="0" style="border:0;" class="mapaContacto" allowfullscreen="" aria-hidden="false" 
    tabindex="0">
    </iframe>

    <div class="elemento list-group list-group-flush" v-for="archivo in contenido.ArchivosDeContenidoMicrositios" :key="archivo.ArchivoDeContenidoMicrositioId">
            <div class="list-group-item">   <b>{{archivo.Titulo}}</b> 
            
            <div v-if="archivo.TextoDescripcion!='EsLink'">
                <li class="lista" v-for="cont in archivo.TextoDescripcion.split('|')" :key="cont.index" > {{cont}} </li><br>          
            </div> 

             <p v-if="archivo.TextoDescripcion=='EsLink'"> 
                <a :href="archivo.RutaDelArchivo" target="_blank"> {{archivo.RutaDelArchivo}} </a>  
            </p> 
            
            </div>

                 

    </div>  

    </div>
    
  


    
</div>
</template>
<script>
export default {
    props:{
        contenidos:Array
    },
    methods: {
        
        columnasContenido(columnas){
            var respuesta = 'col-lg-'+columnas
            return respuesta;
        },
        columnasRestan(columnas){
            var respuesta = 'col-lg-'+ (12-columnas)
            return respuesta;
            
        }
    },
}
</script>
<style scoped>
.lista{
    list-style: none;
}
.titulo{
    background-color: black;
    color: white;
}
.caja-contacto{
    margin-top: 3vh;

  
}
.mapaContacto{
width: 100%;
height: 25rem;
border-radius: 10%;

 

}

hr {
  background-color: white;
  height: 1px;
  margin-left: 0%;
  width: 100%;
}

.contacto{
    /* background-color: aquamarine; */
   background-color:white ;
   border-top: 3vh;
   margin-bottom: 3vh;
   margin-top: 0;
    opacity: 0.8;
    
}

.datos_contacto{
 background-color:white ;
   border-top: 3vh;
   margin-bottom: 3vh;
    opacity: 0.8;
    margin: auto;
    
 padding: 3px 10px;
  border: rgba(190,154,94,.9) 5px solid;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;

}

.contacto h3{ 
    font-size:2em;
    font-family: 'Roboto', sans-serif;
    
    
}

.elemento{
    font-size:1.5em;
    font-family: 'Roboto', sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/components/Micrositios/Formatos/MapaContacto.vue